<template>
  <div class="limit-select">
    <span class="value">
      <slot /> /
    </span>
    <span
      v-if="value === null || !limitActive"
      class="toggle"
      @click="setLimitActive(true)"
    >
      <span class="infinity-symbol">&#8734;</span>
    </span>
    <template v-else>
      <number
        :value="value"
        @input="$emit('input', { value: $event })"
        :min="0"
      />
      <delete
        class="delete"
        size="xs"
        color="danger"
        @click="setLimitActive(false)"
      />
    </template>
  </div>
</template>

<script>
// HACK: need Number for typecheck below, so we have to import wrongly here
import TwNumber from '@/components/editor/input/Number'
import Delete from '@/components/icons/Delete'

export default {
  components: {
    number: TwNumber,
    Delete
  },
  props: {
    enabled: {
      type: Boolean,
      default: false
    },
    value: {
      default: 0,
      type: Number
    }
  },
  data () {
    return {
      limitActive: this.enabled
    }
  },
  methods: {
    setLimitActive (active) {
      if (active) {
        this.limitActive = true
        this.value = 0
        this.$emit('input', { value: this.value })
      } else {
        this.limitActive = false
        this.$emit('input', { value: null })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/uiColors';

.limit-select {
  display: flex;
  align-items: center;
  padding-right: 10px;
  padding-left: 10px;

  /deep/ > label {
    width: auto;
    margin-left: 10px;
  }

  .value {
    white-space: nowrap;
  }

  .toggle {
    margin-left: 5px;

    &:hover {
      cursor: pointer;
    }

    .infinity-symbol {
      font-size: 1.5em;
      &:hover {
        color: $color-main-lighter;
      }
    }
  }

  .delete {
    margin-left: 10px;
  }
}
</style>
